import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { ProductOption } from "./product-option-entity";


export class ProductProductOption extends BaseEntity {

  productCode             : string;
  productOptionCode       : string;
  productOption           : ProductOption;
  rank                    : number;
   
}